import { render, staticRenderFns } from "./gc-tabs.vue?vue&type=template&id=954c57ba&"
import script from "./gc-tabs.vue?vue&type=script&lang=js&"
export * from "./gc-tabs.vue?vue&type=script&lang=js&"
import style0 from "./gc-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports